import { render, staticRenderFns } from "./ScoreStars.vue?vue&type=template&id=72d11e2b&"
import script from "./ScoreStars.vue?vue&type=script&lang=js&"
export * from "./ScoreStars.vue?vue&type=script&lang=js&"
import style0 from "./ScoreStars.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports